import { h } from 'preact';
import Helmet from 'react-helmet';
import { useStore } from 'src/hooks';

const currentYear = new Date().getFullYear();

const Head = () => {
    const ctx = useStore();
    const title = ctx.layout.title.value;
    const titlePrefix = ctx.config.titlePrefix.value;
    const description = ctx.layout.description.value;
    const titleTemplate = `${titlePrefix ? `${titlePrefix} - ` : ''}CamContacts - %s`;

    return (
        <Helmet titleTemplate={titleTemplate}>
            <title>{title}</title>
            <meta name="description" content={description ? description : 'Live Video Chat Webcams'} />
            <meta name="copyright" content={`© ${currentYear} CC Media Network Ltd. All Rights Reserved.`} />
            <meta name="rating" content="RTA-5042-1996-1400-1577-RTA" />
            <meta name="application-name" content="CamContacts" />

            <link rel="preload" href="/com/misc/fonts/arimo.woff2" as="font" crossOrigin="anonymous" />
            <link rel="icon" type="image/png" href="/misc/favicon32x32.png" sizes="32x32" />
            <link rel="icon" type="image/png" href="/misc/favicon96x96.png" sizes="96x96" />
            <link rel="icon" type="image/png" href="/misc/favicon128x128.png" sizes="128x128" />
            <link rel="icon" type="image/png" href="/misc/favicon192x192.png" sizes="192x192" />
            <link rel="icon" type="image/png" href="/misc/favicon512x512.png" sizes="512x512" />
            <link rel="icon" type="image/png" sizes="196x196" href="/misc/favicon196x196.png" />
            <link rel="apple-touch-icon" href="/misc/favicon120x120.png" sizes="120x120" />
            <link rel="apple-touch-icon" href="/misc/favicon152x152.png" sizes="152x152" />
            <link rel="apple-touch-icon" href="/misc/favicon180x180.png" sizes="180x180" />
        </Helmet>
    );
};

export default Head;
